var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 72,
    viewBox: "0 0 69 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M-10.68 0h41.446l3.973 42.677h-49.217z",
    transform: "translate(21.188 19.985)",
    style: {
      strokeWidth: 4,
      strokeLinejoin: "round",
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M4828.542-384.889v-14.5a9.058 9.058 0 0 1 9.382-7.539 8.794 8.794 0 0 1 9.2 7.539v14.5",
    transform: "translate(-4806.558 411.395)",
    style: {
      strokeLinejoin: "bevel",
      strokeWidth: 4,
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 308",
    transform: "translate(33.532 37.997)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 6",
    cx: 16.5,
    cy: 17,
    rx: 16.5,
    ry: 17,
    transform: "translate(.468 .002)",
    style: {
      fill: "#3cbc55"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 514",
    d: "m3653.229 4500.826 4.746 4.746 10.766-10.765",
    transform: "translate(-3643.171 -4482.514)",
    style: {
      strokeWidth: 2,
      strokeLinejoin: "round",
      stroke: "#fff",
      strokeLinecap: "round",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 176",
    style: {
      fill: "none"
    },
    d: "M0 0h69v72H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartGreen);
export default __webpack_public_path__ + "static/media/cart-green.b54eb8f271d3ddde0879109cda4c3547.svg";
export { ForwardRef as ReactComponent };